export default __webpack_public_path__ + "static/media/438.43bd219e.png";